import Spinner from 'components/spinner/spinner.component';

const SpinnerWrapper = ({ loading, children, ...rest }) => {
  if (loading) return <Spinner {...rest} />;
  return children;
};

export default SpinnerWrapper;
